import { render, staticRenderFns } from "./AttachmentSize.vue?vue&type=template&id=7e40f3bc&scoped=true"
import script from "./AttachmentSize.vue?vue&type=script&lang=ts"
export * from "./AttachmentSize.vue?vue&type=script&lang=ts"
import style0 from "./AttachmentSize.vue?vue&type=style&index=0&id=7e40f3bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e40f3bc",
  null
  
)

export default component.exports